import registerCurrentAccountPrompt from "emun.auth/register-current-acct-prompt";

export default $parse => ({
  scope: false,
  link(scope, element, attr) {
    const ngModel = {
      open(e) {
        return registerCurrentAccountPrompt(attr).then(
          args => $parse(attr.onRegistered)(scope, args),
          args => $parse(attr.onDismissed)(scope, args)
        );
      }
    };

    if (attr.ngModel) {
      $parse(attr.ngModel).assign(scope, ngModel);
    }

    const $targets = attr.registerCurrentAccountPromptClickSelector
      ? element.find(attr.registerCurrentAccountPromptClickSelector)
      : element;
    $targets.on("click", ngModel.open);
  }
});
